import React, { useState } from "react";
import navbarLogo from '../../assets/images/diya_logo.svg'
import menuIcon from '../../assets/icons/menu_icon.svg'
import crossIcon from '../../assets/icons/cross_icon.svg'
import { CONSTANTS } from "../../constants/Constants";
import Button from "../Buttons";

interface NavBarProps {
    setRequestDemoScreen: ()=>void
    demoBtnTxt: string
}
const Navbar: React.FC<NavBarProps> = ({
    setRequestDemoScreen,
    demoBtnTxt
}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div
      className="bg-cover layout-container bg-center pt-5 relative mb-0 lg:mb-[60px] w-100"
    >
        {/* <div className="mx-auto mt-[20px] layout-container bg-white z-50"> */}
            <div className="flex items-center gap-5 justify-between">

                <img className="max-w-[160px]" src={navbarLogo} alt="logo" />

                <div className="mt-7">
                    <ul className="hidden lg:flex space-x-10 font-medium w-fit">
                        <li className={`pb-2 ${window.location.hash === "" && "border-b-2 border-black"}`}>
                            <a href="/" className="hover:text-primary transition">{CONSTANTS.HOME_TXT}</a>
                        </li>
                        <li className={`pb-2 ${window.location.hash === "#feature_product" && "border-b-2 border-black"}`}>
                            <a href="#feature_product" className="hover:text-primary transition">{CONSTANTS.FEATURES_PRODUCT_TXT}</a>
                        </li>
                        <li className={`pb-2 ${window.location.hash === "#start_your_journey" && "border-b-2 border-black"}`}>
                            <a href="#start_your_journey" className="hover:text-primary transition">{CONSTANTS.START_YOUR_JOURNEY_TXT}</a>
                        </li>
                        <li className={`pb-2 ${window.location.hash === "#why_choose_us" && "border-b-2 border-black"}`}>
                            <a href="#why_choose_us" className="hover:text-primary transition">{CONSTANTS.WHY_CHOOSE_US_TXT}</a>
                        </li>
                        <li className={`pb-2 ${window.location.hash === "#pricing_packages" && "border-b-2 border-black"}`}>
                            <a href="#pricing_packages" className="hover:text-primary transition">{CONSTANTS.PRICING_PACKAGES_TXT}</a>
                        </li>
                    </ul>
                </div>
                <Button
                    btn_label={demoBtnTxt}
                    on_click_handler={setRequestDemoScreen}
                    other_classes="!w-[132px] !text-[14px] mt-6 !bg-[#23FF9C] !text-[#232323] hidden lg:block"
                />


                {/* Mobile Menu Button */}
                <button
                    className="lg:hidden text-gray-800"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <img
                        src={isOpen ? crossIcon : menuIcon}
                        alt="Menu Icon"
                        className="w-6 h-6 text-red-500 bg-white"
                    />
                </button>
            </div>

            {/* Mobile Menu */}
            <div
                className={`lg:hidden transition-all duration-300 ${isOpen ? "block" : "hidden"
                    }`}
            >
                <ul className="flex flex-col space-y-4 py-4 bg-white shadow-lg rounded-md">
                    <li>
                        <a href="/" className="block px-6 py-2 hover:bg-gray-100">{CONSTANTS.HOME_TXT}</a>
                    </li>
                    <li>
                        <a href="#feature_product" className="block px-6 py-2 hover:bg-gray-100">{CONSTANTS.FEATURES_PRODUCT_TXT}</a>
                    </li>
                    <li>
                        <a href="#start_your_journey" className="block px-6 py-2 hover:bg-gray-100">{CONSTANTS.START_YOUR_JOURNEY_TXT}</a>
                    </li>
                    <li>
                        <a href="#why_choose_us" className="block px-6 py-2 hover:bg-gray-100">{CONSTANTS.WHY_CHOOSE_US_TXT}</a>
                    </li>
                    <li>
                        <a href="#pricing_packages" className="block px-6 py-2 hover:bg-gray-100">{CONSTANTS.PRICING_PACKAGES_TXT}</a>
                    </li>
                    <li>
                        <p onClick={setRequestDemoScreen} className="block px-6 py-2 hover:bg-gray-100">{demoBtnTxt}</p>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Navbar;
